<template>
  <!-- <v-app> -->
    <div>
      <div id="app">
        <router-view/>
      </div>

    </div>
  <!-- </v-app> -->
</template>

<script>
import config from "@/config/config";

// TODO: Use config.
export default {
  created() {
    console.log("APP IS RUNNING!")
    if (config.NODE_ENV === "development") {
      // console.log('Logs are enabled.')
    } else if (config.NODE_ENV === "production") {
      // console.log = () => {}
      // console.error = () => {}
      // console.warn = () => {}
    }
  }
};
</script>


<style lang="scss">
  @import './assets/css/_fonts.scss';
  @import './assets/css/global.scss';

  *,
  *::before,
  *::after {
    box-sizing: border-box;
    margin: 0 0;
    padding: 0 0;
  }

</style>
